import styles from './PlanCardDescription.module.scss';

export const PlanCardDescription = () => {
  return (
    <div className={styles.root}>
      <h5 className={styles.accentTitle}>AI Agent with its own computer</h5>
      <p className={styles.caption}>
        Research with world’s fastest AI deep research. Build and deploy code,
        websites, dashboards and more
      </p>
    </div>
  );
};
